import { get, post, patch } from "../config/user-api";

export const Integration = {
  getAll: () => get(`/integration-account`),
  getById: (id: string) => get(`/integration-account/${id}`),
  create: (data: any) => post(`/integration-account`, data),
  update: (id: string, data: any) => patch(`/integration-account/${id}`, data),
};
